const LEASE_ABSTRACTION_VALIDATION_PAGES = {
  leaseDetails: 'lease-details',
  financials: 'financials',
  leaseComp: 'lease-comp',
};

const normalizeDealId = dealId => (typeof dealId === 'object' ? dealId?.id : dealId);

const getLeaseAbstractionValidationKey = (dealId) => {
  const normalizedDealId = normalizeDealId(dealId);
  return normalizedDealId ? `la_ack_${normalizedDealId}` : null;
};

const getLeaseAbstractionValidationState = (dealId) => {
  const key = getLeaseAbstractionValidationKey(dealId);
  if (!key) return {};
  try {
    return JSON.parse(window.localStorage.getItem(key)) || {};
  } catch (e) {
    return {};
  }
};

const isLeaseAbstractionPageValidated = (dealId, pageKey) => {
  return getLeaseAbstractionValidationState(dealId)[pageKey] === true;
};

const setLeaseAbstractionPageValidated = (dealId, pageKey, isValidated) => {
  const key = getLeaseAbstractionValidationKey(dealId);
  if (!key) return;
  const validationState = getLeaseAbstractionValidationState(dealId);
  if (isValidated) {
    window.localStorage.setItem(key, JSON.stringify({ ...validationState, [pageKey]: true }));
  } else {
    const remainingValidationState = { ...validationState };
    delete remainingValidationState[pageKey];
    if (Object.keys(remainingValidationState).length > 0) {
      window.localStorage.setItem(key, JSON.stringify(remainingValidationState));
    } else {
      window.localStorage.removeItem(key);
    }
  }
};

const clearLeaseAbstractionValidationForDeal = (dealId) => {
  const key = getLeaseAbstractionValidationKey(dealId);
  if (!key) return;
  window.localStorage.removeItem(key);
};

export {
  LEASE_ABSTRACTION_VALIDATION_PAGES,
  clearLeaseAbstractionValidationForDeal,
  getLeaseAbstractionValidationKey,
  isLeaseAbstractionPageValidated,
  setLeaseAbstractionPageValidated,
};
